import { render, staticRenderFns } from "./BoReportStatistics.vue?vue&type=template&id=647b8e9e&scoped=true&"
import script from "./BoReportStatistics.vue?vue&type=script&lang=js&"
export * from "./BoReportStatistics.vue?vue&type=script&lang=js&"
import style0 from "./BoReportStatistics.vue?vue&type=style&index=0&id=647b8e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b8e9e",
  null
  
)

export default component.exports